import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, Input, TemplateRef, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'skl-compact-view',
    templateUrl: 'compact-view.component.html',
    styleUrls: ['./compact-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgTemplateOutlet, AsyncPipe, TranslatePipe]
})

export class CompactViewComponent<TEntity> {

    @HostBinding('class.compact-view') public compactView = true;

    @Input('dataSource') public dataSource$!: BehaviorSubject<TEntity[]>;

    @Input('template') public template!: TemplateRef<unknown>;

    public get noDataCheck(): boolean {
        return !this.dataSource$.value.length;
    }
}
